import { Component } from '@angular/core';
import { NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CompositionService } from '../../../../core/services/composition.service';
import { PeriodService } from '../../../../core/services/period.service';
import { ProfessorAcademicClassroomService } from '../../../../core/services/professor-academic-classroom.service';
import { RoomService } from '../../../../core/services/room.service';
import { AppErrorShow } from '../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../core/utils/app-sweet-alert';
import { GlobalName } from '../../../../core/utils/global-name';
import { LocalStorageService } from '../../../../core/utils/local-stoarge-service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SampleSearchPipe } from '../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../components/loading/loading.component';
import { HeaderComponent } from '../../../admin/layout/includes/header/header.component';
import { TaskListComponent } from '../../../components/task-list/task-list.component';
import { TaskListStudentViewComponent } from '../../../components/task-list-student-view/task-list-student-view.component';

@Component({
    selector: 'app-professor-task-list',
    templateUrl: './professor-task-list.component.html',
    imports: [
        TaskListComponent,
        TaskListStudentViewComponent,
        CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule
    ],
    styleUrls: ['./professor-task-list.component.css']
})
export class ProfessorTaskListComponent {
  buttonsPermission :any|undefined;
 search_text=""
  roles:any[] =[]
  data:any[] =[]
  data2:any[] =[]
  fora:any[] =[]
  texts:any[] =[]
  classrooms:any[] =[]
  courses:any[] =[]
  periods:any[] =[]
  pacs2:any[] =[]
  rooms:any[] =[]
  selected_data:any;
  modalOption:any; 
  fileInput:any; 
  classroomId:any
  periodId:any
  currentId:any
  isDtInitialized:boolean = false
  is_active=null
  loading=false
  pac_id:any
  tag="professors-tasklists"
  text=""
  pg={
    pageSize:10,
    p:0,
    total:0
  }
  role:any
  checkCanSet:any
  user:any

  constructor(
    private spinnerService:NgxSpinnerService,
    private roomService:RoomService,
    private periodService:PeriodService,
    private pacService:ProfessorAcademicClassroomService,
    private compositionService:CompositionService,
    private toastrService:ToastrService,
      config: NgbModalConfig,
      private lsService:LocalStorageService,
    private modalService: NgbModal) {
     config.backdrop = 'static';
     config.keyboard = false;
     }


  ngOnInit(): void {
    this.init()
    this.getActions()
    this.user=this.lsService.get(GlobalName.userName)

  }

  init(){
    this.getPeriods()
    this.getProfessorClassrooms()
    this.getProfessorAcademicClassroomsCourses()
    this.getRooms()
  }


  
 

  getRooms(){
    this.roomService.getByState(1).subscribe((res:any)=>{
      this.rooms=res.data
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des devoirs de maison",err)
    })
  }
  getPeriods(){
    this.periodService.getByState(1).subscribe((res:any)=>{
      this.periods=res.data
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des devoirs de maison",err)
    })
  }

  getProfessorClassrooms(){
    this.pacService.getProfessorAcademicClassrooms().subscribe((res:any)=>{
      this.classrooms=res.data
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des devoirs de maison",err)
    })
  }
  getProfessorAcademicClassroomsCourses(){
    this.pacService.getProfessorAcademicClassroomsCourses().subscribe((res:any)=>{
      this.pacs2=res.data
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des devoirs de maison",err)
    })
  }

  getByClassroomPeriods(){
    this.spinnerService.show()
    this.compositionService.getByClassroomPeriods(this.classroomId, this.periodId).subscribe((res:any)=>{
      this.spinnerService.hide()
      this.data=res.data.data
      this.data2=this.data
      this.checkCanSet=res.data.checkCanSet
    },
    (err:any)=>{
      this.spinnerService.hide()
      AppErrorShow.showError("Gestion des utilisateurs",err)

    })
  }
  


  store(value:any){
    this.loading=true

    value['is_programmed']=true
    this.compositionService.store(value).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
        this.modalService.dismissAll()
        this.getByClassroomPeriods()

    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppErrorShow.showError("Gestion des devoirs de maison",err)

    })
  }
  update(value:any){
    delete value.pac_id
    this.loading=true

    this.compositionService.update(this.selected_data.id,value).subscribe((res:any)=>{
        this.modalService.dismissAll()
        this.loading=false
        this.toastrService.success(res.message)
        this.getByClassroomPeriods()
    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppErrorShow.showError("Gestion des devoirs de maison",err)

    })
  }
  delete(ev:any){
   // if(!this.verifyIfElementChecked()) return ;
    let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
        this.loading=true
    this.compositionService.delete(ev).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
        this.getByClassroomPeriods()
    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppErrorShow.showError("Gestion des devoirs de maison",err)

    })
  }
})
  }
  checked(el?:any){
    this.selected_data=el;
    this.is_active=el.is_active
  }
  verifyIfElementChecked(){
    console.log(this.selected_data)
    if (this.selected_data==null) {
      this.toastrService.warning("Aucun élément selectionné");
      return false;
    }
    return true;
  }



  dismiss(){
    this.modalService.dismissAll()
  }

  add(content:any){
    this.modalService.open(content,{size:'lg'});
  }


  show(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalOption={centered:false,size:"lg"}
    this.modalService.open(content,{size:'lg'});
  }

  edit(event:any,content:any){
    if (this.pacs2.length==0 && this.data.length ==0){
      this.toastrService.warning("Veuillez patienter le chargement des données")

      return;
    } 
    this.selected_data=event
    this.courses= this.pacs2.find((el:any)=>el.id==this.selected_data.pacc?.pac_id).courses
    this.modalService.open(content,{size:'lg'});

  }

  setStatus(event:any){

    this.loading=true
    this.toastrService.warning("Opération en cours")
  
      
        this.compositionService.setState(event.id,event.value).subscribe((res:any)=>{
          this.toastrService.success(res.message)
              this.loading=false
          this.getByClassroomPeriods()
      },
      (err:any)=>{
                    this.loading=false
        console.log(err)
          AppErrorShow.showError("Gestion des devoirs de maison",err)

      })
  }

  

  getActions(){
    // this.buttonsPermission = {
    //   show:AppActionCheck.check(this.tag,'Consultation'),
    //   add:AppActionCheck.check(this.tag,'ajout'),
    //   edit:AppActionCheck.check(this.tag,'edition'),
    //   delete:AppActionCheck.check(this.tag,'suppression'),
    //   status:AppActionCheck.check(this.tag,'statut')
    // };
    this.buttonsPermission={
      show:false,
      add:true,
      edit:true,
      delete:true,
      status:true,
    }
  }



  upload(ev:any){
    if (ev.target.files.length!=0) {
      this.fileInput=ev.target.files[0]
    }
  }

  loadTask1(event:any){
    this.periodId=event.target.value
    if (this.periodId!=undefined && this.classroomId!= undefined) {
      this.getByClassroomPeriods()
    }
  }

  loadTask2(event:any){
    this.classroomId=event.target.value
    if (this.periodId!=undefined && this.classroomId!= undefined) {
      this.getByClassroomPeriods()
    }
  }


  loadCourses(event:any){
  this.courses= this.pacs2.find((el:any)=>el.id==event.target.value).courses
  }

  confirm(id:any){
    let confirmed=AppSweetAlert.confirmBox('success','Note de composition','Voulez vous vraiment confirmer les notes de cette composition élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
        this.spinnerService.show()
    this.compositionService.confirm(id,1).subscribe((res:any)=>{
      this.spinnerService.hide()  
      this.toastrService.success(res.message)
      this.getByClassroomPeriods()
    },
    (err:any)=>{
      this.spinnerService.hide()

      console.log(err)
        AppErrorShow.showError("Gestion des devoirs de maison",err)

    })
  }
})
  }

   filterByProfessor(ev:any) {
    if (ev.target.checked) {
      this.data2=this.data.filter((el:any)=>el.pacc?.pac?.professor_id == this.user?.professor?.id)

    } else {
      this.data2=this.data
    }
    console.log()
  }
}
